import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { HeaderSizeCard, HeaderImagesCard } from '../cards';
import { ModalCardFlow } from '../../_designVariant';

/**
 * Body of the Header / Logo config modal — composes the Size and Images
 * cards. Same contract as the other modal bodies (NavigationModal,
 * FooterModal): purely the inner content, parent owns the dialog wrapper.
 *
 * value shape:
 *   { size:   { logoBarHeight, maxContentWidth, backgroundFullWidth }
 *     images: { logoUrl, backgroundUrl, faviconUrl }
 *   }
 *
 * onChange(section, field, value) — same shape as the other modals.
 * onUploadImage(field, file)      — fired by HeaderImagesCard when the user
 *                                   picks a file. Parent does the actual
 *                                   upload and then calls
 *                                   onChange('images', field, url).
 */
const HeaderLogoModal = ({ value = {}, onChange, onUploadImage, globalHeaderWidth, onChangeGlobalHeaderWidth, theme, t }) => {
    const cardOnChange = (section) => (field, val) => {
        if (onChange) onChange(section, field, val);
    };

    return (
        // Wide modal → flow the cards into two balanced (masonry) columns on
        // large screens so the canvas is actually used; single column otherwise.
        <ModalCardFlow>
            <HeaderSizeCard
                value={value.size}
                onChange={cardOnChange('size')}
                globalHeaderWidth={globalHeaderWidth}
                onChangeGlobalHeaderWidth={onChangeGlobalHeaderWidth}
                theme={theme}
                t={t}
            />
            <HeaderImagesCard
                value={value.images}
                onChange={cardOnChange('images')}
                onUpload={onUploadImage}
                theme={theme}
                t={t}
            />
        </ModalCardFlow>
    );
};

HeaderLogoModal.propTypes = {
    value:         PropTypes.object,
    onChange:      PropTypes.func,
    onUploadImage: PropTypes.func,
    globalHeaderWidth: PropTypes.shape({
        width:       PropTypes.number,
        bgFullWidth: PropTypes.bool,
    }),
    onChangeGlobalHeaderWidth: PropTypes.func,
    theme:         PropTypes.string,
    t:             PropTypes.func,
};

export default HeaderLogoModal;
